const fileSelectHandler = async (e: any, setFiles: React.Dispatch<any>) => {
  const _files = e.target.files;
  setFiles(_files);
};

//* 이미지 파일 여부 검증 (이미지가 아니면 alert 후 false)
const validateImageFile = (file: File): boolean => {
  if (!file.type.startsWith('image/')) {
    alert(
      `파일 "${file.name}"은(는) 허용되지 않는 파일 형식입니다. 이미지 파일만 업로드하세요.`,
    );
    return false;
  }
  return true;
};

//* File을 dataURL 미리보기 문자열로 변환
const readFileAsDataUrl = (file: File): Promise<any> => {
  return new Promise((resolve, reject) => {
    try {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = (e) => resolve(e?.target?.result);
    } catch (error) {
      reject(error);
    }
  });
};

const singleImageSelectHandlerWithPreview = async (
  e: any,
  setFile: React.Dispatch<any>,
  setPreview: React.Dispatch<any>,
) => {
  const _file = e.target.files[0];

  if (!validateImageFile(_file)) {
    e.target.value = ''; // input 요소 초기화
    return;
  }
  setFile(_file);
  const _preview = await readFileAsDataUrl(_file);
  setPreview(_preview);
};

const imageSelectHandlerWithPreview = async (
  e: any,
  setFiles: React.Dispatch<any>,
  setPreviews: React.Dispatch<any>,
) => {
  const _files = e.currentTarget.files;
  setFiles(Array.from(_files));
  const val = await Promise.all(
    [...e.currentTarget.files].map(async (file) => {
      return new Promise<any>((resolve, reject) => {
        try {
          const fileReader = new FileReader();
          fileReader.readAsDataURL(file);
          fileReader.onload = (e) => resolve({ url: e?.target?.result, file } as any);
        } catch (error) {
          reject(error);
        }
      });
    }),
  );
  setPreviews(val);
};

const videoSelectHandlerWithPreview = async (
  e: any,
  setFiles: React.Dispatch<any>,
  setPreviews: React.Dispatch<any>,
) => {
  const _files = e.currentTarget.files;
  setFiles(Array.from(_files));
  setPreviews(
    Array.from(_files).map((file: any) => {
      return file.name;
    }),
  );
};

const audioSelectHandlerWithPreview = async (
  e: any,
  setFiles: React.Dispatch<any>,
  setPreviews: React.Dispatch<any>,
) => {
  const _files = e.currentTarget.files;
  setFiles(Array.from(_files));
  setPreviews(
    Array.from(_files).map((file: any) => {
      return file.name;
    }),
  );
};

const fileBucketUrl = (url: string, type: string) => {
  return `${process.env.REACT_APP_BUCKET_URL}/${type}/${url}`;
};

export {
  fileSelectHandler,
  imageSelectHandlerWithPreview,
  fileBucketUrl,
  videoSelectHandlerWithPreview,
  audioSelectHandlerWithPreview,
  singleImageSelectHandlerWithPreview,
  validateImageFile,
  readFileAsDataUrl,
};
